import CertificateIcon from "../images/CertificateIcon.mjs";

/**
 * Simulation status: ready to run
 * @see {GlyphIcon}
 * @see {CertificateIcon}
 */
const AppSimStatusReadyIcon = class extends CertificateIcon {};

export default AppSimStatusReadyIcon;